import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronLeftMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-left-medium"} maskId="square-filled-radius-0-stroke-1-IconChevronLeftMedium"><path d="M15.207 5.5L8.70703 12L15.207 18.5L14.5 19.207L7.29297 12L14.5 4.79297L15.207 5.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronLeftMedium;
